import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { MESSAGETYPE, SCREEN } from '../../../Common';
import { actions } from '../../modules/Actions';

export interface NotificationStatus {
  isDisp: boolean;
  messageType: string;
  messageText?: string;
}

export type NotificationStatusReducerState = {
  [key: string]: NotificationStatus;
};

const initialNotificationStatus: NotificationStatus = {
  isDisp: false,
  messageType: MESSAGETYPE.NORMAL,
};

const initialNotificationStatusReducer: NotificationStatusReducerState = Object.values(SCREEN)
  .map((value) => value.ID)
  .reduce(
    (obj, key) => ({
      ...obj,
      [key]: initialNotificationStatus,
    }),
    {} as NotificationStatusReducerState
  );

export const NotificationStatusReducer = reducerWithInitialState<NotificationStatusReducerState>(initialNotificationStatusReducer)
  .case(actions.refreshNotificationStatus, (state: NotificationStatusReducerState, screenId: string) => {
    return {
      ...state,
      [screenId]: initialNotificationStatus,
    };
  })
  .case(
    actions.updateNotificationStatus,
    (state: NotificationStatusReducerState, payload: { screenId: string; messageType: string; messageText?: string }) => {
      return {
        ...state,
        [payload.screenId]: {
          isDisp: true,
          messageType: payload.messageType,
          messageText: payload.messageText,
        },
      };
    }
  );
